import { z } from "zod";
import {
  CATEGORY,
  DAYS,
  DEPS,
  ID,
  PLANNED_END_DATE,
  PLANNED_START_DATE,
  QUALITY_CHECK,
  SAFETY_CHECK,
  SUB_CATEGORY,
  TASK_NAME,
} from "./consts";

export const schema = z.object({
  [ID]: z.string().optional(),
  [CATEGORY]: z.string().min(1, "This Field is required"),
  [SUB_CATEGORY]: z.string().min(1, "This Field is required"),
  [TASK_NAME]: z.string().min(1, "This Field is required"),
  [PLANNED_START_DATE]: z.string().optional(),
  [PLANNED_END_DATE]: z.string().optional(),
  [DAYS]: z.string().optional(),
  [SAFETY_CHECK]: z.boolean().optional(),
  [QUALITY_CHECK]: z.boolean().optional(),
  [DEPS]: z.any().optional(),
});

export type formValues = z.infer<typeof schema>;
